import React from 'react';
import jars from '../../assets/images/bunq/icons/1-realjars.svg';
import autopayments from '../../assets/images/bunq/icons/2-autopayments.svg';
import triggers from '../../assets/images/bunq/icons/3-realtimetriggers.svg';
import rules from '../../assets/images/bunq/icons/4-intelligentrules.svg';
import applepay from '../../assets/images/bunq/icons/5-applepay.svg';

const CoworkingSection = () => {
  return (
    <section className="coworking">
      <div className="container">
        <h3 className="coworking__subtitle">5 things we love about</h3>
        <h2 className="coworking__title">
          <span>Flow+</span>
          <span>bunq</span>
        </h2>
        <div className="offers">
          <div className="offers__card">
            <div className="offers__icon">
              <div className="offers__num">1</div>
              <img src={jars} alt="jars" className="offers__img" />
            </div>
            <div className="offers__info">
              <h4 className="offers__title">Real jars</h4>
              <h5 className="offers__subtitle">To manage your money</h5>
              <div className="offers__text">
                With bunq you can create up to 25 real IBAN accounts to budget,
                save and spend money from. For one monthly fee.
              </div>
            </div>
          </div>
          <div className="offers__card">
            <div className="offers__icon">
              <div className="offers__num">2</div>
              <img
                src={autopayments}
                alt="autopayments"
                className="offers__img"
              />
            </div>
            <div className="offers__info">
              <h4 className="offers__title">Automatic payments</h4>
              <h5 className="offers__subtitle">In the background</h5>
              <div className="offers__text">
                bunq supports automatic payments within your own account. Create
                an autopilot for your money with Flow.
              </div>
            </div>
          </div>
          <div className="offers__card">
            <div className="offers__icon">
              <div className="offers__num">3</div>
              <img src={triggers} alt="triggers" className="offers__img" />
            </div>
            <div className="offers__info">
              <h4 className="offers__title">Realtime triggers</h4>
              <h5 className="offers__subtitle">Fast as lighting</h5>
              <div className="offers__text">
                Flow receives realtime triggers from bunq. Your Flows will
                trigger instantly.
              </div>
            </div>
          </div>
          <div className="offers__card">
            <div className="offers__icon">
              <div className="offers__num">4</div>
              <img src={rules} alt="rules" className="offers__img" />
            </div>
            <div className="offers__info">
              <h4 className="offers__title">Intelligent rules</h4>
              <h5 className="offers__subtitle">That fuel your money system</h5>
              <div className="offers__text">
                With Flow+ you can divide your money however you want, use
                percentages, create multi-level Flows, decide if you want to
                manually approve or automatically divide your money.
              </div>
            </div>
          </div>
          <div className="offers__card">
            <div className="offers__icon">
              <div className="offers__num">5</div>
              <img src={applepay} alt="applepay" className="offers__img" />
            </div>
            <div className="offers__info">
              <h4 className="offers__title">Use Apple Pay</h4>
              <h5 className="offers__subtitle">Handsfree paying</h5>
              <div className="offers__text">
                With bunq you can choose from payment cards, virtual cards and
                even Apple Pay to pay from any of the sub-accounts you made.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoworkingSection;
